define('taoQtiItem/qtiXmlRenderer/renderers/interactions/InlineChoiceInteraction',['tpl!taoQtiItem/qtiXmlRenderer/tpl/interactions/blockInteraction'], function(tpl){
    return {
        qtiClass : 'inlineChoiceInteraction',
        template : tpl
    };
});
